import TableRowSkeleton from '@components/common/Table/TableRowSkeleton'

const AssetPreferencesDisplayLoading: React.FC = () => {
  return <TableRowSkeleton height="26px" rows={5} />
}

export default AssetPreferencesDisplayLoading
